import React from 'react'
import { FiChevronRight } from 'react-icons/fi'
import Slider from "react-slick";
import { defaultSettings } from './mock';

export const PopularItem = ({items, title}) =>{

    return (
        <div className='bestprojects'>
             <div className="flex mt-5">
                <h1 className='title'>{title}</h1>
                <div>
                    <a href="##">See All <FiChevronRight/></a>
                </div>
            </div>

            <Slider
                className="bestprojects-slider"
                {...defaultSettings}
                {...{slidesToShow: 5, slidesToScroll: 3}}
            >
                {items.map((item,i)=>(
                    <div className='image' key={'bestprojects-'+i} >
                        <a href="##" target="_blank"  >
                            <div className="over"></div>
                            <img src={`/assets/images/projects/${item.img}.jpg`} className='cover' alt="" />
                        </a>
                        <div className="detail flex">
                            {item.name ? (
                                <h3 className="name">{item.name}</h3>
                            ):(
                                <React.Fragment>
                                    <img src={`/assets/images/faces/${item.user.avatar}.png`} className='avatar' alt="" />
                                    <div className="name">{item.user.name}</div>
                                </React.Fragment>
                            )}
                            
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    )
} 